import React from "react";
import PortfolioImage1 from "../assets/images/portfolio1.jpg";
import PortfolioImage2 from "../assets/images/portfolio2.jpg";
import PortfolioImage3 from "../assets/images/portfolio3.jpg";
import PortfolioImage4 from "../assets/images/portfolio4.jpg";
import PortfolioImage5 from "../assets/images/portfolio5.jpg";
import PortfolioImage6 from "../assets/images/portfolio6.jpg";

const projects = [
    {
        id: 1,
        image: PortfolioImage1,
        title: "Dental AI Diagnostics",
        description:
            "MSc Thesis: Computer vision AI that scans dental images to detect teeth caries and oral health issues. Aims to reduce clinical costs by 50%+ and improve early diagnosis.",
        link: "https://github.com/Rastra17/Dental-Image-AI-Detector--Final-Project-",
        tech: ["Python", "TensorFlow", "CV", "Deep Learning"],
    },
    {
        id: 2,
        image: PortfolioImage2,
        title: "Job Recommendation AI",
        description:
            "BSc Final Project: Collaborative content hybrid model matching candidates with job roles based on skills, achieving 89% accuracy using ML algorithms.",
        link: "https://github.com/Rastra17/Individual-Project",
        tech: ["Python", "ML", "Rec Systems", "Data Science"],
    },
    {
        id: 3,
        image: PortfolioImage3,
        title: "AI Script Generator",
        description:
            "A generative language model that drafts game and movie scripts using NLP. Leverages transformer architecture for creative content generation.",
        link: "https://github.com/Rastra17/Game-Story-Generator",
        tech: ["Python", "NLP", "Transformers", "AI"],
    },
    {
        id: 4,
        image: PortfolioImage4,
        title: "Stock Helper Bot",
        description:
            "Intelligent chatbot with stock market capabilities. Provides real time stock analysis, market insights, and financial advice using NLU and API integrations.",
        link: "https://github.com/Rastra17/Stockbot-Assistant--Lunarix-",
        tech: ["Python", "NLP", "APIs", "Chatbot"],
    },
    {
        id: 5,
        image: PortfolioImage5,
        title: "StyleSassy E Commerce",
        description:
            "Full stack e commerce platform with secure authentication, payment integration, product management, shopping cart, and admin dashboard.",
        link: "https://github.com/Rastra17/StyleSassy",
        tech: ["MERN Stack", "Node.js", "React", "MongoDB"],
    },
    {
        id: 6,
        image: PortfolioImage6,
        title: "ExpansionJJK Mod",
        description:
            "Custom Minecraft mod for Fabric modloader in Java. Adds new gameplay mechanics, items, and features inspired by Jujutsu Kaisen anime.",
        link: "https://github.com/Rastra17/ExpansionJJK",
        tech: ["Java", "Fabric API", "Game Dev", "Modding"],
    },
];

function Portfolio() {
    return (
        <section className="portfolio" id="portfolio">
            <h2 className="heading">
                Latest <span>Projects</span>
            </h2>
            <p
                style={{
                    textAlign: "center",
                    fontSize: "1.6rem",
                    marginBottom: "3rem",
                    maxWidth: "70rem",
                    margin: "0 auto 3rem",
                }}
            >
                A showcase of my work in AI/ML, full stack development, and software
                engineering. Each project represents my commitment to building
                innovative and impactful solutions.
                <br />
                <em style={{ fontSize: "1.4rem", color: "var(--main-color)" }}>
                    Note: GitHub repositories are private. Please contact me via the form
                    below or email if you're interested in viewing the code.
                </em>
            </p>
            <div className="portfolio-container">
                {projects.map((project) => (
                    <div className="portfolio-box" key={project.id}>
                        <img src={project.image} alt={project.title} loading="lazy" />
                        <div className="portfolio-layer">
                            <h4>{project.title}</h4>
                            <p>{project.description}</p>
                            <div className="tech-tags">
                                {project.tech.map((tech, index) => (
                                    <span key={index}>{tech}</span>
                                ))}
                            </div>
                            <a
                                href={project.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label={`View ${project.title} on GitHub`}
                            >
                                <i className="bx bxl-github"></i>
                            </a>
                        </div>
                    </div>
                ))}
            </div>
            <div className="view-all-btn">
                <a
                    href="https://github.com/Rastra17"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn"
                >
                    <i className="bx bxl-github"></i> View All Projects on GitHub
                </a>
            </div>
        </section>
    );
}

export default Portfolio;
